import {
  Globe,
  Zap,
  CheckCircle,
  LockKeyhole,
} from "lucide-react";
import Card from '@/components/common/ui/Card';

const plans = [
  {
      title: "Setup on all domains and servers",
      description:
        "Your SSL can be installed on any domain or extension with no domain limitations.",
      icon: Globe, // Domains, global compatibility
    },
    {
      title: "Easy and fast validation",
      description:
        "Quick domain validation is required to verify ownership before SSL issuance.",
      icon: Zap, // Speed & ease
    },
    {
      title: "Trusted by all major browsers",
      description:
        "Trusted by 99.9% of browsers and mobile devices—on par with premium certificates from Verisign and Thawte.",
      icon: CheckCircle, // Trust & compatibility
    },
    {
      title: "SHA2 & ECC encryption",
      description:
        "Our SSL certificates use advanced SHA-2 and ECC encryption for maximum security.",
      icon: LockKeyhole, // Strong encryption
    },
];

export default function PlanIncluded() {
    return (
        <section className="container pb-24 pt-6">
            <div className="text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Included with all SSL Certificates
                </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}